import React from "react";
import {
  ActivityIndicator,
  StyleSheet,
  TouchableNativeFeedback,
  TouchableOpacity,
  View,
} from "react-native";
import CheckBox from "react-native-checkbox";
import { connect } from "react-redux";
import BankImage from "@assets/svg/WithdrawMoney/Bank";
import Plus from "@assets/svg/WithdrawMoney/Cross";
import Text from "@components/AppText";
import colors from "@constants/color";
import analytics from "@services/analytics";
import { scale, verticalScale } from "@utils/scale";
import InputBox from "./InputBox";
import ModalLoader from "../../components/ModalLoader";
import { STATE_STATUS } from "../../reducers/actionTypes";
import { actions as walletActions } from "../../reducers/oldWalletReducer";
import { actions as ccfpActions } from "../../reducers/ccfpReducer";

import {
  getAllWalletMetaData,
  getWalletSummary,
  validateAmount,
} from "../../services/api";
import PaymentStatusModal from "./PaymentStatusModal";
import {
  CCFP_EVENTS,
  GULLAK_EVENTS,
  OTHER_EVENTS,
} from "@constants/analyticsEventsCT";

import t from "@constants/localization";

const PATH = "screens/WithdrawMoney/WithdrawContent";

const ACCOUNT_TYPE = {
  bank_account: "bank_account",
  vpa: "vpa",
};

const UPI_ID = Symbol("upi_id");

class WithdrawContent extends React.Component {
  state = {
    activeIndex: null,
    amount: {},
    amountError: {},
    amountLoading: false,
    upi: null,
    upiError: null,
    withdrawAllAmount: {},
    bankSelected: true,
    upiSelected: false,
    item: this.props.item,
  };

  reload = false;
  withdrawn = false;

  _menu = null;

  componentDidMount() {
    if (this.props.wallet.fundAccountStatus !== STATE_STATUS.FETCHED) {
      this.props.fetchFundAccounts();
    }
  }

  setMenuRef = (ref) => {
    this._menu = ref;
  };

  hideMenu = () => {
    this._menu.hide();
  };

  showMenu = () => {
    this._menu.show();
  };

  componentDidUpdate() {
    if (
      this.props.wallet.createFundAccountStatus === STATE_STATUS.CREATED &&
      this.reload === true
    ) {
      this.props.fetchFundAccounts();
      this.props.resetFundAccountBank();
      this.reload = false;
    }

    if (
      this.props.wallet.withdrawAmountStatus == STATE_STATUS.CREATE_FAILED &&
      this.withdrawn === true
    ) {
      analytics.trackEvent(GULLAK_EVENTS.TRANSACTION_FAILED, {
        method:
          this.props.item && this.props.item.account_number ? "bank" : "upi",
      });
      this.withdrawn = false;
    }
    if (
      this.props.wallet.withdrawAmountStatus == STATE_STATUS.NOT_CREATED &&
      this.withdrawn === true
    ) {
      analytics.trackEvent(GULLAK_EVENTS.TRANSACTION_FAILED, {
        method:
          this.props.item && this.props.item.account_number ? "bank" : "upi",
      });
      this.withdrawn = false;
    }
    if (
      this.props.wallet.withdrawAmountStatus == STATE_STATUS.CREATED &&
      this.withdrawn === true
    ) {
      analytics.trackEvent(GULLAK_EVENTS.TRANSACTION_SUCCESSFUL, {
        method:
          this.props.item && this.props.item.account_number ? "bank" : "upi",
      });

      this.withdrawn = false;
    }
  }

  setActiveIndex(val) {
    this.setState({
      activeIndex: val,
    });
  }

  checkValidAmount = async (amount) => {
    if (amount.trim()) {
      try {
        let { data } = await validateAmount(amount);
        setIfscDetails(data);
      } catch (e) {}
    } else {
      setIfscDetails(null);
    }
  };

  withdrawMoney = async (payload, from = "default") => {
    if (from === "ccfp") {
      this.props.withdrawMoneyFromCCFP(payload);

      analytics.trackEvent(CCFP_EVENTS.CCFP_DEBITED, {
        amount: payload.amount,
        method: payload.method,
      });
    } else {
      this.props.withdrawMoneyFromGullak(payload);
    }
  };

  validateCCFPAmount = (amount, total) => {
    if (+amount < 10) {
      return { errors: true, message: t(`${PATH}/withdrawMin10rs`) };
    }
    if (+amount > +total) {
      return { errors: true, message: t(`${PATH}/insufficientBal`) };
    }
  };

  renderEnterAmountView = (x) => {
    const { getUpiId, upi_address, upiError } = x;
    const { amountError, amountLoading, withdrawAllAmount } = this.state;
    const { totals = {} } = this.props.wallet.walletSummary;
    const {
      user: { phone_number = "", id = "", name = "" },
    } = this.props || {};

    const { total_fund_balance = 0 } = this.props.ccfp.ccfpSummary;

    const total_balance =
      this.props.from === "ccfp"
        ? (+total_fund_balance).toString()
        : totals
          ? totals.balance
          : "0";

    return (
      <View style={styles.enter_amount_view}>
        <View
          style={{
            width: scale(296),
            marginBottom: verticalScale(16),
            alignSelf: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            height: 1,
          }}
        />
        {getUpiId && (
          <>
            <InputBox
              borderRadius={6}
              containerStyle={{
                flex: 1,
              }}
              placeholder={t(`${PATH}/enterUPI`)}
              value={this.state.upi}
              onChange={(upiID) => {
                this.setState({
                  upi: upiID,
                  upiError: null,
                });
              }}
              error={this.state.upiError !== null}
              // errorMessage={this.state.upiError}
              keyboardType={"default"}
              labelTextColor={colors.primary}
            />
            <Text
              mukta
              fontType="head4"
              style={{
                color: colors.silver,
                marginBottom: 18,
                marginTop: 4,
              }}
            >
              {t(`${PATH}/example`)} : phonenumber@upi
            </Text>
            {this.state.upiError && (
              <Text
                style={{
                  color: colors.internationalOrange,
                  marginBottom: 0,
                  position: "absolute",
                  right: 32,
                  top: 36,
                }}
                disabled={true}
                fontType="content2"
              >
                {this.state.upiError}
              </Text>
            )}
          </>
        )}
        <View
          style={{
            flexDirection: "row",
            marginBottom: 12,
          }}
        >
          <InputBox
            borderRadius={6}
            showRupee={true}
            bold={true}
            containerStyle={{
              flex: 1,
              marginRight: 6,
            }}
            placeholder={t(`${PATH}/enterAmount`)}
            error={amountError[x.id] ? true : false}
            value={this.state.amount[x.id]}
            onChange={(amount) => {
              this.setState({
                amount: {
                  ...this.state.amount,
                  [x.id]: amount,
                },
                amountError: {},
                withdrawAllAmount: {
                  ...this.state.withdrawAllAmount,
                  [x.id]: false,
                },
              });
            }}
            keyboardType={"number-pad"}
            labelTextColor={colors.primary}
          />
          <TouchableOpacity
            disabled={!this.state.amount[x.id]}
            onPress={async () => {
              if (getUpiId && !/^\w+@\w+$/.test(this.state.upi)) {
                this.setState({
                  upiError: t(`${PATH}/enterAValidUPI`),
                });
                return;
              }
              this.setState({
                amountLoading: true,
              });

              try {
                if (this.props.from && this.props.from === "ccfp") {
                  let data = this.validateCCFPAmount(
                    this.state.amount[x.id],
                    total_fund_balance,
                  );
                  if (data && data.errors) {
                    this.setState({
                      amountError: {
                        ...this.state.amountError,
                        [x.id]: data.message,
                      },
                      amountLoading: false,
                    });
                    return;
                  }
                } else if (this.props.from && this.props.from !== "ccfp") {
                  let { data } = await validateAmount(
                    this.state.amount[x.id],
                    x.default_mode,
                  );
                  if (data && data.errors && data.errors.length > 0) {
                    this.setState({
                      amountError: {
                        ...this.state.amountError,
                        [x.id]: data.errors[0].message,
                      },
                      amountLoading: false,
                    });

                    return;
                  }
                }
              } catch (e) {
                let data = e.response && e.response.data;
                if (data && data.errors && data.errors.length > 0) {
                  this.setState({
                    amountError: {
                      ...this.state.amountError,
                      [x.id]: data.errors[0].message,
                    },
                    amountLoading: false,
                  });
                  return;
                }
              }

              this.setState({
                amountLoading: false,
              });

              if (getUpiId) {
                if (!this.state.upi) {
                  this.setState({
                    upiError: t(`${PATH}/enterAValidUPI`),
                  });
                  return;
                }
                this.props.createFundAccountVpa({
                  account_type: ACCOUNT_TYPE.vpa,
                  upi_address: this.state.upi,
                  amount: Number(this.state.amount[x.id]),
                });
                this.setState({
                  amount: {},
                  activeIndex: null,
                });
                this.reload = true;
                return;
              } else {
              }
              this.withdrawMoney(
                {
                  fund_account_id: x.id,
                  amount: this.state.amount[x.id],
                  mode: x.default_mode,
                },
                this.props.from,
              );
              this.setState({
                amount: {},
                activeIndex: null,
              });
              this.reload = true;
              this.withdrawn = true;
            }}
            style={[
              styles.enter_amount_button,
              {
                backgroundColor: !this.state.amount[x.id]
                  ? colors.silver
                  : colors.primary,
                alignSelf: "flex-start",
              },
            ]}
          >
            {this.state.amountLoading ? (
              <ActivityIndicator size="small" color={colors.white} />
            ) : (
              <Text bold mukta fontType="head3" style={{ color: colors.white }}>
                {t(`${PATH}/withdraw`)}
              </Text>
            )}
          </TouchableOpacity>
        </View>
        {amountError[x.id] && (
          <Text
            style={{ color: colors.internationalOrange, marginBottom: 8 }}
            disabled={true}
            fontType="content2"
          >
            {amountError[x.id]}
          </Text>
        )}
        <CheckBox
          label={t(`${PATH}/withdrawAllMoney`)}
          checked={withdrawAllAmount[x.id]}
          checkedImage={require("../../assets/svg/WithdrawMoney/BoxChecked.webp")}
          uncheckedImage={require("../../assets/svg/WithdrawMoney/BoxUnChecked.webp")}
          onChange={() => {
            this.setState({
              withdrawAllAmount: {
                ...this.state.withdrawAllAmount,
                [x.id]: !withdrawAllAmount[x.id],
              },
              amount: {
                ...this.state.amount,
                [x.id]: withdrawAllAmount[x.id] ? null : total_balance,
              },
            });
          }}
        />
      </View>
    );
  };

  renderMaskedAccountNumber = (value) => {
    return (
      value.substring(0, 2) +
      value.substring(2, value.length - 2).replace(/\d/g, "X") +
      value.substring(value.length - 2)
    );
  };

  renderUpi(x) {
    const {
      user: { phone_number = "", id = "", name = "" },
    } = this.props || {};
    const { activeIndex } = this.state;
    const {
      account_number,
      user_name,
      upi_address,
      is_blacklisted,
      account_type,
    } = x;
    return (
      <TouchableNativeFeedback
        key={account_number}
        background={TouchableNativeFeedback.Ripple(colors.mercury)}
        onPress={async () => {
          this.props.navigation.navigate("WithdrawFromAcc", { item: x });
          this.setActiveIndex(x.id === activeIndex ? null : x.id);
        }}
      >
        <View
          style={[
            styles.account_view,
            {
              height: "auto",
            },
          ]}
        >
          <View
            style={{
              opacity: 1,
            }}
          >
            <View
              style={{
                flexDirection: "row",
              }}
            >
              <View
                style={{
                  marginTop: verticalScale(10),
                  justifyContent: "center",
                  alignItems: "center",
                  width: scale(30),
                  height: scale(30),
                  borderRadius: scale(15),
                  backgroundColor: colors.accountIcon,
                }}
              >
                <Text bold style={{ fontSize: 14, color: "#fff" }}>
                  {upi_address && upi_address.charAt(0).toUpperCase()}
                </Text>
              </View>

              <View
                style={{
                  flex: 1,
                  marginLeft: 12,
                }}
              >
                <Text
                  mukta
                  fontType="head3"
                  style={[
                    styles.primaryHeading,
                    {
                      color: "rgba(0, 0, 0, 0.56)",
                    },
                  ]}
                >
                  {upi_address && upi_address}
                </Text>
                <Text
                  bold
                  mukta
                  fontType="head3"
                  style={[
                    styles.secondaryHeading,
                    {
                      color: "rgba(0, 0, 0, 0.87)",
                    },
                  ]}
                >
                  {upi_address}
                </Text>
              </View>
            </View>
            {this.renderEnterAmountView(x)}
          </View>
        </View>
      </TouchableNativeFeedback>
    );
  }

  renderBanks(x) {
    const {
      user: { phone_number = "", id = "", name = "" },
    } = this.props || {};
    const { activeIndex } = this.state;

    const { account_number, user_name, is_blacklisted } = x;
    return (
      <TouchableNativeFeedback
        key={account_number}
        background={TouchableNativeFeedback.Ripple(colors.mercury)}
      >
        <View
          style={[
            styles.account_view,
            {
              height: "auto",
            },
          ]}
        >
          <View
            style={{
              opacity: 1,
            }}
          >
            <View
              style={{
                flexDirection: "row",
              }}
            >
              <View
                style={{
                  marginTop: verticalScale(10),
                  justifyContent: "center",
                }}
              >
                <BankImage />
              </View>

              <View
                style={{
                  flex: 1,
                  marginLeft: 12,
                }}
              >
                <Text
                  mukta
                  fontType="head3"
                  style={[
                    styles.primaryHeading,
                    {
                      color: "rgba(0, 0, 0, 0.56)",
                    },
                  ]}
                >
                  {user_name}
                </Text>
                <Text
                  bold
                  mukta
                  fontType="head3"
                  style={[
                    styles.secondaryHeading,
                    {
                      color: "rgba(0, 0, 0, 0.87)",
                    },
                  ]}
                >
                  {this.renderMaskedAccountNumber(account_number)}
                </Text>
              </View>
            </View>
            {this.renderEnterAmountView(x)}
          </View>
        </View>
      </TouchableNativeFeedback>
    );
  }

  renderJoinNewBank() {
    const {
      navigation,
      user: { phone_number = "", id = "", name = "" },
    } = this.props;

    return (
      <TouchableOpacity
        onPress={async () => {
          // await analytics.trackEvent(JOIN_NEW_BANK, {
          //   screen: "WithdrawMoney",
          //   leader_id: id,
          //   leader_phone_number: phone_number,
          //   leader_name: name,
          // });
          navigation.navigate("AddBankDetails");
        }}
        style={styles.add_new_account}
      >
        <Plus size={20} color={colors.primary} />
        <Text mukta fontType="head4" style={{ marginLeft: 8 }}>
          {t(`${PATH}/addNewBankAcc`)}
        </Text>
      </TouchableOpacity>
    );
  }

  render() {
    const { navigation, wallet, ccfp } = this.props;
    let bankAccounts = [],
      upiAccounts = [];
    const {
      user: { phone_number = "", id = "", name = "" },
    } = this.props || {};

    if (wallet.fundAccountStatus === STATE_STATUS.FETCHED) {
      for (let i = 0; i < wallet.fundAccountsData.length; i++) {
        let account = wallet.fundAccountsData[i];
        if (account.account_type === ACCOUNT_TYPE.bank_account) {
          bankAccounts.push(account);
        }
        if (account.account_type === ACCOUNT_TYPE.vpa) {
          upiAccounts.push(account);
        }
      }
    }

    return (
      <View style={styles.container}>
        <ModalLoader
          loading={wallet.fundAccountStatus === STATE_STATUS.FETCHING}
        />
        <PaymentStatusModal
          from={this.props.from}
          onRequestClose={async () => {
            if (this.props.from && this.props.from === "ccfp") {
              await this.props.refreshCCFPSummary();
            } else {
              //reset wallet actions here
              await this.props.resetWithdrawMoney();
            }
            this.props.navigation.navigate("Home");
          }}
          status={
            this.props.from === "ccfp"
              ? ccfp.withdrawStatus
              : wallet.withdrawAmountStatus
          }
          resetWithdrawMoney={async () => {
            this.props.resetWithdrawMoney();
            getAllWalletMetaData()
              .then(({ data }) => {
                const {
                  default: { toDate, fromDate },
                } = data.filters;
                this.props.setWalletMetaData(data);
                getWalletSummary({ to: toDate, from: fromDate }).then(
                  ({ data }) => {
                    this.props.setWalletSummary(data);
                  },
                );
              })
              .catch((e) => {
                console.log(e);
              });
          }}
        />

        {wallet.fundAccountStatus === STATE_STATUS.FETCHED &&
          wallet.fundAccountsData.length > 0 && (
            <>
              {this.state.item.account_type == ACCOUNT_TYPE.bank_account &&
                this.renderBanks(this.state.item)}
              {this.state.item.account_type == ACCOUNT_TYPE.vpa &&
                this.renderUpi(this.state.item)}
            </>
          )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingVertical: 18,
    height: "100%",
  },
  enter_amount_view: {
    marginTop: 12,
    // backgroundColor: "#f7f7f7",
    padding: 16,
    paddingVertical: 20,
    borderRadius: 6,
  },
  enter_amount_button: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 6,
    borderRadius: 6,
    paddingVertical: 14,
  },
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerContainer: {
    padding: 10,
  },
  primaryHeading: {
    // marginBottom: 12,
    marginBottom: 6,
  },
  secondaryHeading: {
    color: colors.lightBlack,
  },
  add_bank_button: {
    backgroundColor: colors.primary,
    height: verticalScale(54),
    width: "100%",
    marginVertical: 24,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: scale(10),
    flexDirection: "row",
  },
  add_new_account: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: colors.white,
    justifyContent: "flex-start",
    padding: 14,
    borderRadius: 6,
    elevation: 1,
    marginVertical: 4,
  },
  black_listed_view: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 8,
  },
  account_view: {
    flex: 1,
    overflow: "hidden",
    marginVertical: 4,
    overflow: "hidden",
    backgroundColor: colors.white,
    // elevation: 1,

    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,

    borderRadius: 6,
    padding: 16,
  },
});

const mstp = ({ wallet, ccfp, auth: { user } }) => {
  return {
    wallet,
    user,
    ccfp,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFundAccounts: () => dispatch(walletActions.fetchFundAccounts()),
    createFundAccountBank: (payload) =>
      dispatch(walletActions.createFundAccountBank(payload)),
    createFundAccountVpa: (payload) =>
      dispatch(walletActions.createFundAccountVpa(payload)),
    withdrawMoneyFromGullak: (payload) =>
      dispatch(walletActions.withdrawMoney(payload)),
    resetWithdrawMoney: () => dispatch(walletActions.resetWithdrawMoney()),
    resetFundAccountBank: () => dispatch(walletActions.resetFundAccountBank()),
    setWalletMetaData: (data) =>
      dispatch(walletActions.setWalletMetaData(data)),
    setWalletSummary: (data) => dispatch(walletActions.setWalletSummary(data)),
    withdrawMoneyFromCCFP: (payload) =>
      dispatch(ccfpActions.withdrawMoney(payload)),
    refreshCCFPSummary: () => dispatch(ccfpActions.fetchCCFPSummary()),
  };
};

export default connect(mstp, mapDispatchToProps)(WithdrawContent);
